import React from "react";
import {
  Box,
  Typography,
  Container,
  ThemeProvider,
  createTheme,
  CssBaseline,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const theme = createTheme({
  palette: {
    primary: { main: "#0f63a5" },
  },

});

const steps = [
  {
    label: "Apply",
    desc: "Submit your application and showcase your expertise",
  },
  {
    label: "Connect",
    desc: "Meet our team and discuss opportunities",
  },
  {
    label: "Evaluate",
    desc: "Demonstrate your skills and potential",
  },
  {
    label: "Join",
    desc: "Welcome to the Rajiv Williams family",
  },
];

const Journey: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <Box sx={{ py: 12, backgroundColor: "#f9fafb" }}>
        <Container>
          {/* Title */}
          <Box sx={{ mb: 10 }}>
            <Typography
              sx={{
                fontSize: { xs: "2rem", md: "3rem" },
                color: "#0f63a5",
                fontWeight: 500,
              }}
            >
              Your Journey
            </Typography>

            {/* underline */}
            {/* <Box
              sx={{
                width: 60,
                height: 3,
                backgroundColor: "#d4af37",
                mt: 1,
              }}
            /> */}
          </Box>

          {/* Timeline */}
          <Box sx={{ position: "relative", mt: 6 }}>
            {/* Main line */}
            <Box
              sx={{
                position: "absolute",
                top: 22,
                left: "10%",
                right: "10%",
                height: 3,
                backgroundColor: "#0f63a5",
                zIndex: 1,
              }}
            />

            {/* Gold end line */}
            <Box
              sx={{
                position: "absolute",
                top: 22,
                right: "10%",
                width: "10%",
                height: 3,
                backgroundColor: "#d4af37",
                zIndex: 1,
              }}
            />

            {/* Steps */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                position: "relative",
                zIndex: 2,
              }}
            >
              {steps.map((step, index) => (
                <Box
                  key={index}
                  sx={{
                    textAlign: "center",
                    width: "25%",
                  }}
                >
                  {/* Circle */}
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      border:
                        index === steps.length - 1
                          ? "none"
                          : "3px solid #0f63a5",
                      backgroundColor:
                        index === steps.length - 1
                          ? "#0f63a5"
                          : "#fff",
                      color:
                        index === steps.length - 1
                          ? "#fff"
                          : "#0f63a5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto",
                      fontWeight: 600,
                    }}
                  >
                    {index === steps.length - 1 ? (
                      <CheckIcon />
                    ) : (
                      index + 1
                    )}
                  </Box>

                  {/* Title */}
                  <Typography
                    sx={{
                      mt: 3,
                      fontWeight: 600,
                      fontSize: "1.2rem",
                    }}
                  >
                    {step.label}
                  </Typography>

                  {/* Description */}
                  <Typography
                    sx={{
                      mt: 1,
                      fontSize: "0.95rem",
                      color: "#555",
                      maxWidth: 220,
                      margin: "0 auto",
                      lineHeight: 1.6,
                    }}
                  >
                    {step.desc}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default Journey;